/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import at from 'lodash/at';
import get from 'lodash/get';
import { sanitizeInnerHtml } from '../../utils';
import { getCSSVariables } from '../../cruxComponents/utils';

const Wrapper = styled.div`
  padding: ${({ padding }) =>
    padding?.[0]?.['reviewBreadcrumb-wrapper'] || padding?.[1]?.['reviewBreadcrumb-wrapper']};
  width: 100%;
  h1 {
    margin: 0;
    padding: 0;
    font-weight: bold;
    color: ${({ color }) => color};
  }
`;

const BreadCrumbHeader = styled.h2`
  font-size: ${({ fontSize }) => fontSize};
  font-weight: ${({ fontWeight }) => fontWeight};
  @media (max-width: 640px) {
    font-size: 28px !important;
  }
  @media (max-width: 420px) {
    font-size: 22px !important;
  }
`;

const ReviewBreadcrumb = ({ question, theme }) => {
  const color = get(theme, 'config.theme.pageOverrides.review.headerColor', '#ffffff');

  // CSS Variables
  const cssVariables = getCSSVariables(theme);
  const padding = at(cssVariables, ['pageOverride.padding', 'global.padding']);
  const breadcrumbHeaderFontSize = get(
    theme,
    'config.theme.pageOverrides.review.breadcrumbHeaderFont',
    '',
  );
  const breadcrumbHeaderFontWeight = get(
    theme,
    'config.theme.pageOverrides.review.breadcrumbHeaderFontWeight',
    '',
  );

  const { question_text: questionText, question_id: questionId } = question;
  return (
    <Wrapper name='wrapper' color={ color } padding={ padding }>
      <BreadCrumbHeader
        name='breadcrumb-text'
        id={ questionId }
        fontSize={ breadcrumbHeaderFontSize }
        fontWeight={ breadcrumbHeaderFontWeight }
      >
        {/* nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml */}
        <span dangerouslySetInnerHTML={ { __html: sanitizeInnerHtml(questionText) } } />
      </BreadCrumbHeader>
    </Wrapper>
  );
};

ReviewBreadcrumb.propTypes = {
  question: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withTheme(ReviewBreadcrumb);
